<template>
  <authenticated-layout>
    <page-header
      :title="$t('components.UserSettingsPage.title')"
    />

    <!-- Debug translation: {{ $t('components.UserSettingsPage.title') }} -->

    <v-container fluid class="pa-0 fill-height">
      <v-row>
        <v-col cols="2" xl="2" align-self="stretch">
          <v-list color="transparent" density="compact" class="border rounded-lg py-0">
            <v-list-item
              :to="{ name: 'userSettingsProfile' }"
              active-class="bg-primary"
              title="Profile"
            />
            <v-list-item
              :to="{ name: 'userSettingsPassword' }"
              active-class="bg-primary"
              title="Password"
            />
            <v-list-item
              :to="{ name: 'userSettingsAppearance' }"
              active-class="bg-primary"
              title="Appearance"
            />
          </v-list>
        </v-col>
        <v-col cols="10" xl="10" class="pt-0">
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </authenticated-layout>
</template>

<script setup lang="ts">
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";

</script>
